import AXIOS from '@/axios-instance';

export default {
  retrieveUserQuestions() {
    return AXIOS.get("/user/questions");
  },
  answerQuestion(answer, questionId) {
    return AXIOS.post("/bpmn/question/"+ questionId +"/answer", answer);
  },
  async retrieveUserForId(userId){
    let user = await AXIOS.get('/user/' + userId);
    return user;
  }
}